import { createSlice } from "@reduxjs/toolkit";


const tankGradesSettingSlice = createSlice({
    name: "tankGradesSetting",
    initialState: {
        tankData: [],
        gradesData: []
    },
    reducers: {
        setTankData: (state, action) => {
            state.tankData = action.payload;
        },
        setGradesData: (state, action) => {
            state.gradesData = action.payload;
        },
    }
});

export const {
    setTankData,
    setGradesData
} = tankGradesSettingSlice.actions;

export default tankGradesSettingSlice.reducer;
